import Vue from 'vue'
import Router from 'vue-router'
import MenuView from '@/views/common/MenuView'
import PageView from '@/views/common/PageView'
import LoginView from '@/views/login/Common'
import EmptyPageView from '@/views/common/EmptyPageView'
import GlobalLayout from '@/views/common/GlobalLayout'
import HomePageView from '@/views/HomePage'
import db from 'utils/localstorage'
import request from 'utils/request'

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

let constRouter = [
	{
		path: '/login',
		name: '登录页',
		component: LoginView
	},
	{
		path: '/index',
		name: '首页',
		redirect: '/home',
//  children:[
//  	{
//      path: 'orderDetail',
//      name: '订单详情-审批',
//      component: () => import('@/views/order/order/orderDetail'),
//    },
//  ]
	},
	{
		path: '/user-sign',
		name: '签名',
		component: () => import('@/views/system/user/UserSign'),
	},
	{
		path: '/order',
		// redirect: '/order/standardOrder',
		name: '主页',
		component: MenuView,
		children: [
			{
				path: 'addStandardOrder',
				name: '添加标准订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'editOrder',
				name: '编辑订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'editStandardOrder',
				name: '编辑标准订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'addNonStandardOrder',
				name: '添加非标准订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'addPurchaseOrder',
				name: '添加采购订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'addMediumOrder',
				name: '添加平台订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'addBrokerOrder',
				name: '添加经纪人订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'addBusinessDevelopmentOrder',
				name: '添加商务拓展订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'addNewMarketOrder',
				name: '添加新市场订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'addRedbookBusinessOrder',
				name: '添加小红书商务订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'addOwnOrder',
				name: '添加自接单订单',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'operation',
				name: '操作中',
				component: () => import('@/views/order/dataOrder/operation'),
			},
			{
				path: 'standardOrderDetail',
				name: '标准订单详情',
				component: () => import('@/views/order/standardOrderDetail/standardOrderDetail'),
			},
			{
				path: 'orderDetail',
				name: '订单详情',
				component: () => import('@/views/order/order/orderDetail'),
			},
			{
				path: 'bloggerOrderDetail',
				name: '订单详情-博主',
				component: () => import('@/views/order/order/bloggerOrderDetail'),
			},
			{
				path: 'participantOrderDetail',
				name: '订单详情-参与者',
				component: () => import('@/views/order/order/participantOrderDetail'),
			},
			{
				path: 'procurementOrderDetail',
				name: '采购订单详情',
				component: () => import('@/views/order/procurementOrderDetail/procurementOrderDetail'),
			},
			{
				path: 'agreementDetail',
				name: '单项合同详情',
				component: () => import('@/views/order/agreement/agreementDetail/agreementDetail'),
			},
			{
				path: 'agreementYearFrameDetail',
				name: '年框合同详情',
				component: () => import('@/views/order/agreement/agreementDetail/agreementYearFrameDetail'),
			},
			{
				path: 'agreementSupplierDetail',
				name: '供应商合同详情',
				component: () => import('@/views/order/agreement/agreementDetail/agreementSupplierDetail'),
			},
			{
				path: 'employeeFileDetail',
				name: '职员附件',
				component: () => import('@/views/order/agreement/employee/employeeFileDetail'),
			}
		]
	},
	{
		path: '/todoTask',
		name: '主页',
		component: MenuView,
		children: [
			{
				path: 'orderDetail',
				name: '订单详情-审批',
				component: () => import('@/views/order/order/orderDetail'),
			},
			{
				path: 'editOrder',
				name: '编辑订单-重新提交',
				component: () => import('@/views/order/addStandardOrder/addStandardOrder'),
			},
			{
				path: 'agreementDetail',
				name: '合同详情',
				component: () => import('@/views/order/agreement/agreementDetail/agreementDetail'),
			},
		]
	},
	{
		path: '/account',
		// redirect: '/order/standardOrder',
		name: '主页',
		component: MenuView,
		children: [
			{
				path: 'accountDetail',
				name: '账号详情',
				component: () => import('@/views/account/accountDetail/accountDetail'),
			},
			{
				path: 'orderDetail',
				name: '订单详情',
				component: () => import('@/views/order/order/orderDetail'),
			},
			{
				path: 'weiboList',
				name: '微博',
				component: () => import('@/views/account/weibo/weiboList'),
			},
			{
				path: 'weixinList',
				name: '公众号',
				component: () => import('@/views/account/weixin/weixinList'),
			},
			{
				path: 'douyinList',
				name: '抖音',
				component: () => import('@/views/account/douyin/douyinList'),
			},
			{
				path: 'bilibiliList',
				name: 'B站',
				component: () => import('@/views/account/blibli/blibliList'),
			},
			{
				path: 'redbookList',
				name: '小红书',
				component: () => import('@/views/account/redbook/redbookList'),
			},
			{
				path: 'kuaishouList',
				name: '快手',
				component: () => import('@/views/account/kuaishou/kuaishouList'),
			},
			{
				path: 'momentsList',
				name: '朋友圈',
				component: () => import('@/views/account/moments/momentsList'),
			},
			{
				path: 'channelsList',
				name: '视频号',
				component: () => import('@/views/account/channels/channelsList'),
			},
			{
				path: 'taobaoList',
				name: '淘宝',
				component: () => import('@/views/account/taobao/taobaoList'),
			},
			{
				path: 'jingdongList',
				name: '京东',
				component: () => import('@/views/account/jingdong/jingdongList'),
			},
			{
				path: 'pinduoduoList',
				name: '拼多多',
				component: () => import('@/views/account/pinduoduo/pinduoduoList'),
			},
			{
				path: 'otherList',
				name: '其他平台',
				component: () => import('@/views/account/other/otherList'),
			},
		]
	},
	{
		path: '/workManage',
		// redirect: '/order/standardOrder',
		name: '主页',
		component: MenuView,
		children: [
			{
				path: 'dataReport',
				name: '数据详情',
				component: () => import('@/views/workManage/dadaReport/dadaReport'),
			},
			{
				path: 'bilibiliDataDetail',
				name: 'B站数据详情',
				component: () => import('@/views/workManage/dadaReport/bilibiliDataDetail'),
			}
		]
	},
	{
		path: '/workflow',
		// redirect: '/order/standardOrder',
		name: '主页',
		component: MenuView,
		children: [
			{
				path: 'nodeSettings',
				name: '数据节点',
				component: () => import('@/views/workflow/process/nodeSettings'),
			},
			{
				path: 'nodeSettingsUser',
				name: '流程启动配置',
				component: () => import('@/views/workflow/process/nodeSettingsUser'),
			},
			{
				path: 'nodePreposeSettings',
				name: '节点注意事项配置',
				component: () => import('@/views/workflow/process/nodePreposeSettings'),
			}
		]
	},
	{
		path: '/employee',
		// redirect: '/order/standardOrder',
		name: '主页',
		component: MenuView,
		children: [
			{
				path: 'newEntry',
				name: '入职表',
				component: () => import('@/views/OA/peopleSummary/newEntry')
			},
			{
				path: 'rosterInformation',
				name: '人员详细信息',
				component: () => import('@/views/OA/peopleSummary/rosterInformation')
			},
			{
				path: 'rosterInformationOutAndSign',
				name: '独立运营/签约人员信息',
				component: () => import('@/views/OA/peopleSummary/rosterInformationOutAndSign')
			},
		]
	},
	{
		path: '/OA',
		// redirect: '/order/standardOrder',
		name: '主页',
		component: MenuView,
		children: [
			{
				path: 'meeting',
				name: '会议列表',
				component: EmptyPageView,
				children: [
					{
						path: 'meetingDetails',
						name: '会议列表详情',
						component: () => import('@/views/OA/meeting/meetingList/meetingDetails')
					}
				]
			},
			{
				path: 'addTalentPool',
				name: '新增人才资源库',
				component: () => import('@/views/OA/recruit/addTalentPool'),
			},
			{
				path: 'editTalentPool',
				name: '编辑人才资源库',
				component: () => import('@/views/OA/recruit/editTalentPool'),
			},
			{
				path: 'talentDetails',
				name: '人才资料详情',
				component: () => import('@/views/OA/recruit/talentDetails'),
			},
			{
				path: 'operation',
				name: '操作详情',
				component: () => import('@/views/OA/operation/operation'),
			}
		]
	},
	{
		path: '/',
		redirect: '/home',
		// name: '主页',
		component: MenuView,
		children: [
			{
				path: 'noticeList',
				name: '我的消息',
				component: () => import('@/views/system/notice/noticeList'),
			},
			{
				path: 'officialList',
				name: '公文列表',
				component: () => import('@/views/system/notice/officialList'),
			},
			{
				path: 'noticeDetail',
				name: '公告详情',
				component: () => import('@/views/system/notice/noticeDetail')
			}
		]
	},
	{
		path: '/commission',
//  redirect: '/home',
		name: '提成绩效管理',
		component: MenuView,
		children: [
			{
				path: 'bloggerOrderDetail',
				name: '订单详情-博主',
				component: () => import('@/views/order/order/bloggerOrderDetail'),
			}
		]
	},
	{
			path: '/invoiceManagement',
			name: '发票管理',
			component: MenuView,
			children: [
				{
					path: 'addInvoice',
					name: '新增发票',
					component: () => import('@/views/connection/invoice/addInvoice/newAddInvoice'),
				},
				{
					path: 'editInvoice',
					name: '编辑发票',
					component: () => import('@/views/connection/invoice/addInvoice/newAddInvoice'),
				},
				{
					path: 'supplementaryInvoice',
					name: '补录发票',
					component: () => import('@/views/connection/invoice/addInvoice/newAddInvoice'),
				}
			]
	},
	{
		path: '/brandV2',
		name: '品牌管理',
		component: MenuView,
		children: [
			{
				path: 'brandV2List',
				name: '品牌列表V2',
				component: () => import('@/views/brand/brandV2List/brandV2List'),
			},
			{
				path: 'myBrandV2List',
				name: '我的品牌库V2',
				component: () => import('@/views/brand/brandV2List/myBrandV2List'),
			},
			{
				path: 'brandV2Detail/:id',
				name: '品牌详情',
				component: () => import('@/views/brand/brandV2List/brandV2Detail'),
			}
		]
	},
]

let router = new Router({
	routes: constRouter
})

const whiteList = ['/login','/user-sign']

let asyncRouter

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {

	let token = db.get('USER_TOKEN')
	let user = db.get('USER')
	let userRouter = get('USER_ROUTER')
	if (token.length && user) {
		if (!asyncRouter) {
			if (!userRouter) {
				request.get(`menu/${user.username}`).then((res) => {
					asyncRouter = res.data
					console.log(asyncRouter)
					save('USER_ROUTER', asyncRouter)
					go(to, next)
				})
			} else {
				asyncRouter = userRouter
				go(to, next)
			}
		} else {
			next()
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			next()
		}else{
			next('/login')
		}

	}
})

function go (to, next) {
	asyncRouter = filterAsyncRouter(asyncRouter)
	router.addRoutes(asyncRouter)
	next({...to, replace: true})
}

function save (name, data) {
	localStorage.setItem(name, JSON.stringify(data))
}

function get (name) {
	return JSON.parse(localStorage.getItem(name))
}

function filterAsyncRouter (routes) {
	return routes.filter((route) => {
		let component = route.component
		if (component) {
			switch (route.component) {
				case 'MenuView':
					route.component = MenuView
					break
				case 'PageView':
					route.component = PageView
					break
				case 'EmptyPageView':
					route.component = EmptyPageView
					break
				case 'HomePageView':
					route.component = HomePageView
					break
				default:
					route.component = view(component)
			}
			if (route.children && route.children.length) {
				route.children = filterAsyncRouter(route.children)
			}
			return true
		}
	})
}

function view (path) {
	return function (resolve) {
		import(`@/views/${path}.vue`).then(mod => {
			resolve(mod)
		})
	}
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js